import React, { useState } from 'react'
import styles from './TableLine.module.scss'
import { TableLineContainer } from 'components/common'
import { Props } from './types'
import { IconWatching, IconInteract, IconRevenue, IconTotalBill } from 'assets'
import { StatisticElement } from '../../StatisticElement'
import { ViewerInfoLine } from 'components/viewers'

const TableLineComponent = (props: Props) => {
  const [expanded, setExpanded] = useState(false)
  const { viewer } = props

  const toggleExpand = () => {
    setExpanded(state => !state)
  }

  return (
    <TableLineContainer preset='material' noBoxShadow={!expanded}>
      <ViewerInfoLine
        viewer={viewer}
        toggleExpand={toggleExpand}
        expanded={expanded}
      />
      {expanded &&
        <div className={styles.extend}>
          <StatisticElement
            icon={IconWatching}
            label='Total watch time'
            value={viewer.totalWatchTimeAsString}
          />
          <StatisticElement
            icon={IconInteract}
            label='Total page interaction time'
            value={viewer.totalInteractionTimeAsString}
          />
          <StatisticElement
            icon={IconRevenue}
            label='Ad revenue'
            value={viewer.totalAddRevenueAsString}
          />
          <StatisticElement
            icon={IconTotalBill}
            label='Total spend'
            value={viewer.totalSpentAsString}
          />
        </div>}
    </TableLineContainer>
  )
}

const TableLine = TableLineComponent
export { TableLine }
